module.exports = __webpack_public_path__ + "media/Sponteneous Combustion.18a0307e.mp3";